<template>
  <div class="form-floating">

    <Transition>
      <div class="notificacion" v-if="errorForm">
        <span>{{ errorMessage }}</span>
      </div>
    </Transition>
    <div class="step1" v-if="editionLinkMode === false">

      <span id="#">Modelo del reproductor: </span>
        <div class="options">
            <div class="item" @click="changeMode('slim')" :style="[ mode == 'slim' ? {'border-color': 'rgba(255, 0, 0, 0.658)'} : {'border-color': 'rgba(128, 128, 128, 0.158)'}]" >
                <img :src="slim" width="200" height="120"/>
                <span>Slim</span>
            </div>
            <div class="item" @click="changeMode('vertical')" :style="[ mode == 'vertical' ? {'border-color': 'rgba(255, 0, 0, 0.658)'} : {'border-color': 'rgba(128, 128, 128, 0.158)'}]">
                <img :src="vertical" width="200" height="120"/>
                <span>Vertical</span>
            </div>
            <div class="item" @click="changeMode('minimal')" :style="[ mode == 'minimal' ? {'border-color': 'rgba(255, 0, 0, 0.658)'} : {'border-color': 'rgba(128, 128, 128, 0.158)'}]">
                <img :src="minimal" width="200" height="120"/>
                <span>Minimal</span>
            </div>
        </div>

    </div>
    <div>

      <div v-if="editionLinkMode === true">
        <div class="linkInput">

          <span>Editar enlace</span>
          
          <input class="form-control dataInputs" 
          v-model="linkEditInput" 
          placeholder="Enlace de audio" 
          />
          
          <input class="form-control dataInputs" 
          v-model="metadataEditInput" 
          placeholder="Enlace de Metadata" 
          />
          
          <input class="form-control dataInputs" 
          v-model="programmingEditInput" 
          placeholder="Enlace de Programacion" 
          />

          <div class="d-flex bloqueSpacing">
            <button class="btn btn-danger me-4" @click="confirmEditLink(oldLinkId)">Confirmar</button>
            <button class="btn btn-warning" @click="cancelEditLink">Cancelar</button>
          </div>
        </div>
      </div>

  <div class="bloqueSpacingSpecial" v-if="editionLinkMode === false">

    <!-- Sección 1: Tipo de configuración -->
    <div class="section-card">
      <h3 class="section-title">1. Tipo de configuración</h3>
      <p class="section-subtitle">Elegí cuántas emisoras va a tener este reproductor.</p>
      <div class="radio-options">
        <label class="radio-option" :class="{active: radioMode === 'radio'}">
          <input
            class="form-check-input"
            type="radio"
            name="inlineRadioOptions"
            id="inlineRadio1"
            @click="selectingMode('radio')"
            checked
            required
            value="option1">
          <div class="radio-content">
            <span class="radio-label">Radio Única</span>
            <small class="radio-desc">1 sola emisora — la mayoría de los casos.</small>
          </div>
        </label>
        <label class="radio-option" :class="{active: radioMode === 'multiradio'}">
          <input
            class="form-check-input"
            type="radio"
            name="inlineRadioOptions"
            id="inlineRadio2"
            required
            @click="selectingMode('multiradio')"
            value="option2">
          <div class="radio-content">
            <span class="radio-label">Multi-Radio</span>
            <small class="radio-desc">Para medios de comunicación con más de 1 emisora.</small>
          </div>
        </label>
      </div>
    </div>

    <!-- Sección 2: Datos de la radio -->
    <div class="section-card">
      <h3 class="section-title">2. Datos de la radio</h3>
      <p class="section-subtitle">Información obligatoria de la emisora.</p>

      <div class="row-2col">
        <div class="field-group">
          <label class="field-label" for="fld-nombre">Nombre de la radio <span class="req">*</span></label>
          <input
            id="fld-nombre"
            class="form-control"
            required
            placeholder="Ej. Radio Frecuencia"
            v-model="currentStationToAdd"
            :disabled="radioMode == 'radio' && stations.length > 0 && editionMode == false">
        </div>
        <div class="field-group">
          <label class="field-label" for="fld-slogan">Eslogan <span class="req">*</span></label>
          <input
            id="fld-slogan"
            class="form-control"
            type="text"
            required
            placeholder="Ej. Tu música, tu compañía"
            :disabled="radioMode == 'radio' && stations.length > 0 && editionMode == false"
            v-model="defaultSlogan">
        </div>
      </div>

      <div class="row-logo">
        <div class="field-group logo-input-area">
          <label class="field-label" for="formFile">Logo / imagen de portada <span class="req">*</span></label>
          <input
            class="form-control"
            type="file"
            id="formFile"
            accept="image/*"
            ref="fileInputType"
            @change="previewfile">
          <small class="field-hint">Recomendado 400×400px. Formatos: PNG, JPG, WEBP.</small>
        </div>
        <div class="logo-preview-area">
          <img class="previewImage" v-if="preview" width="120" height="120" :src="preview">
          <div v-else class="previewPlaceholder">Vista previa</div>
        </div>
      </div>
    </div>

    <!-- Sección 3: Enlaces de Streaming -->
    <div class="section-card">
      <h3 class="section-title">3. Enlaces de Streaming</h3>
      <p class="section-subtitle">URL del audio principal de la emisora y backups opcionales.</p>

      <div class="field-group">
        <label class="field-label">Streaming Principal <span class="req">*</span></label>
        <small class="field-hint">Servidor + puerto + path. Solo permitidos servidores Inovanex.</small>
        <div class="streamingFields mt-2">
          <select class="form-select streamingServerSelect"
            v-model="streamingServer"
            :disabled="radioMode == 'radio' && stations.length > 0 && editionMode == false">
            <option value="cdn.instream.audio">cdn.instream.audio</option>
            <option value="ipanel.instream.audio">ipanel.instream.audio</option>
          </select>
          <input class="form-control streamingPortInput"
            type="number" min="1" max="65535"
            v-model="streamingPort"
            placeholder="Puerto"
            :disabled="radioMode == 'radio' && stations.length > 0 && editionMode == false"/>
          <input class="form-control streamingPathInput"
            v-model="streamingPath"
            placeholder="/stream"
            :disabled="radioMode == 'radio' && stations.length > 0 && editionMode == false"/>
        </div>
        <small class="streamingPreview" v-if="streamingPort">
          URL final: <code>{{ mainStreaming }}</code>
        </small>
      </div>

      <div class="field-group">
        <label class="field-label">Streamings de backup <span class="optional">(opcional)</span></label>
        <small class="field-hint">Backups si el principal falla. Podés contratar con nosotros un 2do streaming en otra locación y agregarlo como backup — consultar en todo caso.</small>
        <div class="backupAddRow mt-2">
          <input class="form-control"
            v-model="linkInput"
            placeholder="https://otro-servidor.com:8000/stream"
            :disabled="radioMode == 'radio' && stations.length > 0 && editionMode == false"/>
          <button class="btn btn-outline-danger" type="button" @click="pushLink">+ Añadir</button>
        </div>
        <ul class="backupsList">
          <li class="linkLi" v-for="(link, index) in currentLinkList" :key="index">
            <div class="liData">
              <input v-model="link.link" class="form-control dataInputs">
            </div>
            <div class="LiPanel">
              <div class="upDown">
                <UpIcon @click="changeLinkPosition('up', link.link, index)"></UpIcon>
              </div>
              <TrashIcon class="trashIcon" @click="deleteLink(link.link)"></TrashIcon>
            </div>
          </li>
        </ul>
      </div>
    </div>

    <!-- Sección 4: Metadata y Programación (opcional) -->
    <div class="section-card">
      <h3 class="section-title">4. Metadata y programación <span class="optional-badge">opcional</span></h3>
      <p class="section-subtitle">Campos opcionales para enriquecer la información del player.</p>

      <div class="field-group">
        <label class="field-label">Enlace de Metadata</label>
        <input class="form-control"
          v-model="metadataInput"
          placeholder="https://..."
          :disabled="radioMode == 'radio' && stations.length > 0 && editionMode == false"/>
      </div>
      <div class="field-group">
        <label class="field-label">Enlace de Programación</label>
        <input class="form-control"
          v-model="programmingInput"
          placeholder="https://..."
          :disabled="radioMode == 'radio' && stations.length > 0 && editionMode == false"/>
      </div>

      <small class="helperNote">
        ⓘ Para que funcione la <b>programación</b> se necesita la <b>app Inovanex en última versión</b> y tener la programación cargada en el panel de las apps.
      </small>
    </div>

    <!-- Sección 5: Diseño -->
    <div class="section-card">
      <h3 class="section-title">5. Diseño</h3>
      <p class="section-subtitle">Personalizá los colores y la fuente del reproductor.</p>

      <div class="row-design">
        <div class="field-group field-color">
          <label class="field-label">Color principal</label>
          <input class="colorPicker"
            :style="{borderColor: colorTheme}"
            v-model="colorTheme"
            type="text"
            data-coloris>
        </div>
        <div class="field-group field-color">
          <label class="field-label">Color de texto</label>
          <input class="colorPicker"
            :style="{borderColor: colorTheme2}"
            v-model="colorTheme2"
            type="text"
            data-coloris>
        </div>
        <div class="field-group field-font">
          <label class="field-label">Fuente tipográfica</label>
          <div class="font-dropdown" :class="{'font-dropdown-open': fontDropdownOpen}" ref="fontDropdownRef">
            <button type="button" class="font-dropdown-trigger" @click.stop="fontDropdownOpen = !fontDropdownOpen">
              <span class="font-dropdown-current" :style="{fontFamily: fontTheme}">{{ getCurrentFontLabel() }}</span>
              <span class="font-dropdown-caret">▾</span>
            </button>
            <ul class="font-dropdown-menu" v-show="fontDropdownOpen">
              <li
                v-for="opt in fontOptions"
                :key="opt.value"
                class="font-dropdown-item"
                :class="{'font-dropdown-item-active': fontTheme === opt.value}"
                :style="{fontFamily: opt.preview}"
                @click="selectFont(opt.value)">
                {{ opt.label }}
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>

  <div v-if="editionMode === false" class="mt-5">
    <button 
    class="btn btn-danger" 
    @click="confirm"
    >{{ radioMode == 'radio' ? 'Guardar Radio' : 'Añadir Nueva Radio' }}</button>
  </div>

  <div v-else-if="editionMode == true && radioMode !== ''" class="editionButtons">
    <button 
    class="btn btn-primary" 
    @click="confirmEdition(oldStationName)"
    >Guardar cambios</button>

    <button 
    class="btn btn-danger" 
    @click="cancelEdition"
    >Cancelar</button>
  </div>

  <div class="stationsList" v-show="editionMode === false || radioMode === 'multiradio'">
      <div class="card stationCard" v-for="(station, index) in stations" :key="station.station_name">
        <div class="buttonsStations">
          <TrashIcon @click="deleteStation(station.station_name)"></TrashIcon>
          <EditIcon @click="editStation(station.station_name)"></EditIcon>
          <LeftIcon @click="changeRadioPosition(index)"></LeftIcon>
        </div>
        <img :src="station.imgPreview" width="44" height="44" class="radioImgPreview">
        <p>Nombre de la radio: {{ station.station_name }}</p><br/>
        <p>Numero de enlaces: {{ station.station_links.length }}</p><br/>
      </div>
  </div>

  <div class="d-grid gap-2 bloqueSpacing" v-if="stations.length > 0 && editionMode === false">
    <button 
    class="btn btn-danger" 
    type="button" 
    @click="generatePlayer"
    v-if="loading !== true"
    >Generar Reproductor</button>
  </div>
  </div>

  <div class="d-flex justify-content-center pt-4 pb-4" v-if="loading == true">

    <div class="loader"></div>

  </div>

  <div v-if="codeview" class="iframe-result">
    <div class="iframe-result-header">
      <span class="iframe-result-title">Código del reproductor</span>
      <a
        :href="`https://player-radio-streaming.inovanex.com/${mode}/${paramToPlayer}`"
        target="_blank"
        rel="noopener"
        class="btn btn-outline-danger btn-sm iframe-open-link">
        Ver reproductor en otra pestaña ↗
      </a>
    </div>
    <div class="codespace" v-if="mode == 'slim'">
      &lt;iframe
      id=&quot;player&quot;
      title=&quot;playergenerated&quot;
      width=&quot;700&quot;
      height=&quot;1000&quot;
      src=&quot;https://player-radio-streaming.inovanex.com/slim/{{paramToPlayer}}&quot;&gt;
      &lt;/iframe&gt;
    </div>
    <div class="codespace" v-else-if="mode == 'vertical'">
      &lt;iframe
      id=&quot;player&quot;
      title=&quot;playergenerated&quot;
      width=&quot;1000&quot;
      height=&quot;700&quot;
      src=&quot;https://player-radio-streaming.inovanex.com/vertical/{{paramToPlayer}}&quot;&gt;
      &lt;/iframe&gt;
    </div>
    <div class="codespace" v-else-if="mode == 'minimal'">
      &lt;iframe
      id=&quot;player&quot;
      title=&quot;playergenerated&quot;
      width=&quot;800&quot;
      height=&quot;200&quot;
      src=&quot;https://player-radio-streaming.inovanex.com/minimal/{{paramToPlayer}}&quot;&gt;
      &lt;/iframe&gt;
    </div>
  </div>
    </div>
  </div>
</template>

<script>
import {ref, watch, onMounted, onBeforeUnmount} from 'vue';
import axios from 'axios';
import EditIcon from './icons/EditIcon.vue'
import TrashIcon from './icons/TrashIcon.vue'
import UpIcon from './icons/UpIcon.vue'
import LeftIcon from './icons/LeftIcon.vue'


export default {
  components:{
    EditIcon,
    TrashIcon,
    UpIcon,
    LeftIcon,
    },
  setup(){
    // Variables del form
    const currentStationToAdd = ref('');
    const linkInput = ref('');
    const currentLinkList = ref([]);
    const radioMode = ref('radio');
    const metadataOn = ref(false);
    const metadataInput = ref('');
    const programmingInput = ref('');
    const preview = ref();
    const mainStreaming = ref(''); // Main Streaming (URL final compuesta)
    const streamingServer = ref('cdn.instream.audio');
    const streamingPort = ref('');
    const streamingPath = ref('/stream');
    const loading = ref(false);
    const defaultSlogan = ref(''); // Eslogan por default
    const logoOrCover = ref(1);
    const jsonMedia = ref(''); // Json de la metadata
    const codeview = ref(false);
    const paramToPlayer = ref('');
    const metadataLink = ref('');
    const editionMode = ref(false);
    const oldStationName = ref('');
    const mode = ref('vertical');
    const slim = ref(require('../assets/slim.png'));
    const vertical = ref(require('../assets/vertical.png'));
    const minimal = ref(require('../assets/minimal.png'));
    const colorTheme = ref('#cd2327');
    const colorTheme2 = ref('#e2e2e2')
    const defaultImage = ref(null);
    const fontTheme = ref('Poppins');
    const errorForm = ref(false);
    const errorMessage = ref('');
    const fileInputType = ref(null)

    // Lista de fuentes con label visible y font-family de preview
    const fontOptions = [
      { value: 'Poppins', label: 'Poppins', preview: 'Poppins, sans-serif' },
      { value: 'Roboto Mono', label: 'Roboto Mono', preview: '"Roboto Mono", monospace' },
      { value: 'Montserrat', label: 'Montserrat', preview: 'Montserrat, sans-serif' },
      { value: 'Raleway', label: 'Raleway', preview: 'Raleway, sans-serif' },
      { value: 'Playwrite DE Grund', label: 'Play Write', preview: '"Playwrite DE Grund", cursive' },
      { value: 'Lato', label: 'Lato', preview: 'Lato, sans-serif' },
      { value: 'Arimo', label: 'Helvetica', preview: 'Arimo, sans-serif' },
      { value: 'Inter', label: 'Inter', preview: 'Inter, sans-serif' },
      { value: 'Open Sans', label: 'Open Sans', preview: '"Open Sans", sans-serif' },
      { value: 'Quicksand', label: 'Quicksand', preview: 'Quicksand, sans-serif' },
      { value: 'Oswald', label: 'Oswald', preview: 'Oswald, sans-serif' },
      { value: 'Bebas Neue', label: 'Bebas Neue', preview: '"Bebas Neue", sans-serif' },
      { value: 'DM Sans', label: 'DM Sans', preview: '"DM Sans", sans-serif' },
      { value: 'Source Sans 3', label: 'Source Sans 3', preview: '"Source Sans 3", sans-serif' },
      { value: 'Merriweather', label: 'Merriweather', preview: 'Merriweather, serif' },
    ]
    const fontDropdownOpen = ref(false)
    const fontDropdownRef = ref(null)
    const selectFont = (value) => {
      fontTheme.value = value
      fontDropdownOpen.value = false
    }
    const getCurrentFontLabel = () => {
      const found = fontOptions.find(o => o.value === fontTheme.value)
      return found ? found.label : 'Seleccioná una fuente'
    }
    const closeFontDropdownOnClickOutside = (e) => {
      if (fontDropdownRef.value && !fontDropdownRef.value.contains(e.target)) {
        fontDropdownOpen.value = false
      }
    }
    onMounted(() => document.addEventListener('click', closeFontDropdownOnClickOutside))
    onBeforeUnmount(() => document.removeEventListener('click', closeFontDropdownOnClickOutside))

    // Composición automática de la URL del Streaming Principal a partir de los 3 campos
    watch([streamingServer, streamingPort, streamingPath], () => {
      const port = String(streamingPort.value || '').trim()
      if (port === '') {
        mainStreaming.value = ''
        return
      }
      let path = (streamingPath.value || '').trim()
      if (path === '') path = '/stream'
      if (!path.startsWith('/')) path = '/' + path
      mainStreaming.value = `https://${streamingServer.value}:${port}${path}`
    })

    // Parsea una URL guardada (caso edit dentro de la sesión) de vuelta a los 3 campos.
    // Solo aplica si el host coincide con la lista permitida; si no, deja los defaults.
    const parseStreamingUrl = (url) => {
      if (!url) {
        streamingPort.value = ''
        streamingPath.value = '/stream'
        return
      }
      try {
        const u = new URL(url)
        const allowed = ['cdn.instream.audio', 'ipanel.instream.audio']
        if (allowed.includes(u.hostname)) {
          streamingServer.value = u.hostname
          streamingPort.value = u.port || ''
          streamingPath.value = u.pathname || '/stream'
        }
      } catch (e) { /* parse fail: mantener valores actuales */ }
    }

    //Inputs de edicion
    const editionLinkMode = ref(false)
    const linkEditInput = ref('');
    const metadataEditInput = ref('');
    const programmingEditInput = ref('');
    const oldLinkId = ref('')

    // Data a enviar
    const stations = ref([]);
    const config = ref();

    // Funciones del form
    const pushLink = () => {
      if(linkInput.value !== ''){

        const radio = {
          link: linkInput.value,
        }

        currentLinkList.value.push(radio)
        linkInput.value = '';
      }
    }

    const changeLinkPosition = (action ,actualLink, currentIndex) => {
      const beforeValue = currentIndex - 1
      let temp = currentLinkList.value[currentIndex]
      let tempBefore = currentLinkList.value[beforeValue]
      if(temp && tempBefore){
        currentLinkList.value[beforeValue] = temp
        currentLinkList.value[currentIndex] = tempBefore
      }
    }

    // Mover prioridad de Radio
    const changeRadioPosition = (currentIndex) => {
      console.log(currentIndex)
      const beforeValue = currentIndex - 1;
      const temp = stations.value[currentIndex];
      const tempBefore = stations.value[beforeValue];
      if(temp && tempBefore){
        stations.value[beforeValue] = temp;
        stations.value[currentIndex] = tempBefore;
      }
    }

    const changeMode = (val) => {
            mode.value = val
    }

    const deleteLink = (link) => {
      let newLinks = []
      console.log(link)
      currentLinkList.value.forEach((val) => {
        if(val.link !== link){
          newLinks.push(val)
        }
      })
      currentLinkList.value = newLinks
      console.log(newLinks)
    }

    const selectingMode = (mode) => {
      radioMode.value = mode
    }

    const handleMetada = () =>{
      metadataOn.value = !metadataOn.value
    }

    const deleteStation = (stationName) => {
      let newStations = []
      stations.value.forEach(val => {
        if(val.station_name !== stationName){
          newStations.push(val)
        }
      })

      stations.value = newStations
    }

    const editLink = (link) => {
      editionLinkMode.value = true
      const result = currentLinkList.value.find(val => val.link === link);
      console.log(result)
      oldLinkId.value = result.link
      linkEditInput.value = result.link
      programmingEditInput.value = result.programming
      metadataEditInput.value = result.metadata
    }

    const cancelEditLink = () => {
      editionLinkMode.value = false
      linkEditInput.value = ''
      programmingEditInput.value = ''
      metadataEditInput.value = ''
    }

    const editStation = (stationName) => {
      editionMode.value = true
      const result = stations.value.find(val => val.station_name === stationName);
      preview.value = result.imgPreview
      parseStreamingUrl(result.station_links[0].link)
      let backup = result.station_links
      backup = backup.shift()
      console.log(backup)
      currentLinkList.value = result.station_links
      defaultSlogan.value = result.slogan
      currentStationToAdd.value = result.station_name
      metadataInput.value = result.metadata
      oldStationName.value = stationName
      programmingInput.value = result.programming
      defaultImage.value = result.cover
      window.scrollTo({top: 2, left: 0, behavior: 'smooth'})
    }

    const confirmEditLink = (link) => {
      let linkValues = []
      currentLinkList.value.forEach(val => {
        if(val.link == link){
          const linkData = {
            link: linkEditInput.value,
            metadata: metadataEditInput.value,
            programming: programmingEditInput.value,
          }
          linkValues.push(linkData)
        }else{
          linkValues.push(val)
        }
      })
      console.log(linkValues)
      currentLinkList.value = linkValues
      editionLinkMode.value = false
      cancelEditLink()
    }

    const confirmEdition = (stationName) => {
      let stationValues = []
      const main = mainStreaming.value
      let audioBackups = currentLinkList.value
      audioBackups.unshift({link: main})
      console.log(audioBackups)
      stations.value.forEach((val)=> {
        if(val.station_name == stationName){
          const station = {
            station_name: currentStationToAdd.value,
            station_links: audioBackups,
            metadata: metadataInput.value,
            slogan: defaultSlogan.value,
            imgPreview: preview.value,
            cover: defaultImage.value,
            programming: programmingInput.value,
          }
          stationValues.push(station)
        }else{
          stationValues.push(val)
        }
      })
      stations.value = stationValues
      editionMode.value = false
      cancelEdition()
    }

    const cancelEdition = () => {
      editionMode.value = false
      currentLinkList.value = ''
      defaultSlogan.value = ''
      currentStationToAdd.value = ''
      metadataInput.value = ''
      oldStationName.value = ''
      programmingInput.value = ''
      streamingServer.value = 'cdn.instream.audio'
      streamingPort.value = ''
      streamingPath.value = '/stream'
      preview.value = null
      defaultImage.value = null
    }

    const confirm = () => {
      errorForm.value = false
      // Validación campo por campo (campos obligatorios)
      const missing = []
      if (!currentStationToAdd.value || String(currentStationToAdd.value).trim() === '') missing.push('Nombre de la radio')
      if (!defaultSlogan.value || String(defaultSlogan.value).trim() === '') missing.push('Eslogan')
      if (!defaultImage.value) missing.push('Logo (imagen de portada)')
      if (!streamingPort.value || String(streamingPort.value).trim() === '') missing.push('Puerto del Streaming Principal')
      if (missing.length > 0) {
        errorMessage.value = `Faltan campos obligatorios: ${missing.join(', ')}`
        errorForm.value = true
        setTimeout(function(){
          errorForm.value = false
        }, 5000);
        return
      }
      currentLinkList.value.unshift({ link: mainStreaming.value })
      const station = {
        station_name: currentStationToAdd.value,
        station_links: currentLinkList.value,
        metadata: metadataInput.value,
        slogan: defaultSlogan.value,
        imgPreview: preview.value,
        cover: defaultImage.value,
        programming: programmingInput.value
      }
      stations.value.push(station)
      currentLinkList.value = [];
      currentStationToAdd.value = '';
      defaultSlogan.value = ''
      jsonMedia.value = ''
      metadataInput.value = ''
      streamingServer.value = 'cdn.instream.audio'
      streamingPort.value = ''
      streamingPath.value = '/stream'
      preview.value = ''
      programmingInput.value = ''
      defaultImage.value = null
      fileInputType.value = null
      linkInput.value = ''
    }

    const addStation = () => {
      const newStation = {
        station_name: currentStationToAdd.value
      }

      console.log(newStation)
    }

    const previewfile = (event) => {
      console.log(event)
      const form = new FormData();
      form.append('defaultImage', event.target.files[0])
      defaultImage.value = event.target.files[0]
      preview.value = URL.createObjectURL(event.target.files[0])
    }

    const generatePlayer = async () => {
      loading.value = true;

      const newConfig = {
        multiradio: radioMode.value === 'radio' ? 1 : 2,
        metadata: metadataOn.value === true ? 'metadata' : 'nometadata',
        default_slogan: defaultSlogan.value,
        logo_img: defaultImage.value,
        json_cover: jsonMedia.value,
        color: colorTheme.value,
        color2: colorTheme2.value,
        font: fontTheme
      }

      config.value = newConfig;

      const data = new FormData() 

      stations.value.forEach((val, index) => {
        data.append('covers', val.cover, val.station_name + index)
      })
      data.append('station', JSON.stringify(stations.value))
      data.append('config', JSON.stringify(config.value))  

      const url = 'https://player-radio-backend.inovanex.com/create';
      //const url = 'http://localhost:3000/create'
      console.log(data)

      axios.post(url, data)
      .then( function (res){
        if(res.status == 200){
          const resName = res.data.name.replace(/\s/g, '')
          paramToPlayer.value = resName
          loading.value = false
          codeview.value = true
        }
      })
      .catch( function (error){
        console.log(error)
      })

    }

    const logoHandler = (option) => {
      if(option == 'logo'){
        logoOrCover.value = 1
      }else{
        logoOrCover.value = 2
      }
    }

    return { 
      stations, 
      currentStationToAdd, 
      addStation, 
      currentLinkList, 
      linkInput, 
      pushLink, 
      confirm,
      selectingMode,
      radioMode,
      metadataOn,
      handleMetada,
      previewfile,
      preview,
      config,
      generatePlayer,
      loading,
      defaultSlogan,
      logoHandler,
      logoOrCover,
      jsonMedia,
      codeview,
      paramToPlayer,
      mode,
      slim,
      vertical,
      minimal,
      changeMode,
      deleteStation,
      metadataLink,
      editStation,
      editionMode,
      confirmEdition,
      cancelEdition,
      oldStationName,
      deleteLink,
      changeLinkPosition,
      changeRadioPosition,
      metadataInput,
      programmingInput,
      colorTheme,
      colorTheme2,
      programmingEditInput,
      metadataEditInput,
      linkEditInput,
      editLink,
      editionLinkMode,
      cancelEditLink,
      confirmEditLink,
      oldLinkId,
      fontTheme,
      fontOptions,
      fontDropdownOpen,
      fontDropdownRef,
      selectFont,
      getCurrentFontLabel,
      errorForm,
      errorMessage,
      mainStreaming,
      streamingServer,
      streamingPort,
      streamingPath,
      fileInputType
    }
  }
}
</script>

<style setup>
@import url('https://fonts.googleapis.com/css2?family=Space+Mono:ital,wght@0,400;0,700;1,400;1,700&display=swap');
@import url('https://fonts.googleapis.com/css2?family=Roboto+Mono:ital,wght@0,100..700;1,100..700&display=swap');
@import url('https://fonts.googleapis.com/css2?family=Montserrat:ital,wght@0,100..900;1,100..900&family=Roboto+Mono:ital,wght@0,100..700;1,100..700&display=swap');
@import url('https://fonts.googleapis.com/css2?family=Montserrat:ital,wght@0,100..900;1,100..900&family=Raleway:ital,wght@0,100..900;1,100..900&family=Roboto+Mono:ital,wght@0,100..700;1,100..700&display=swap');
@import url('https://fonts.googleapis.com/css2?family=Montserrat:ital,wght@0,100..900;1,100..900&family=Playwrite+DE+Grund:wght@100..400&family=Raleway:ital,wght@0,100..900;1,100..900&family=Roboto+Mono:ital,wght@0,100..700;1,100..700&display=swap');
@import url('https://fonts.googleapis.com/css2?family=Lato:ital,wght@0,100;0,300;0,400;0,700;0,900;1,100;1,300;1,400;1,700;1,900&family=Poppins:ital,wght@0,100;0,200;0,300;0,400;0,500;0,600;0,700;0,800;0,900;1,100;1,200;1,300;1,400;1,500;1,600;1,700;1,800;1,900&display=swap');
@import url('https://fonts.googleapis.com/css2?family=Arimo:ital,wght@0,400..700;1,400..700&display=swap');
@import url('https://fonts.googleapis.com/css2?family=Inter:wght@100..900&display=swap');
@import url('https://fonts.googleapis.com/css2?family=Open+Sans:ital,wght@0,300..800;1,300..800&display=swap');
@import url('https://fonts.googleapis.com/css2?family=Quicksand:wght@300..700&display=swap');
@import url('https://fonts.googleapis.com/css2?family=Oswald:wght@200..700&display=swap');
@import url('https://fonts.googleapis.com/css2?family=Bebas+Neue&display=swap');
@import url('https://fonts.googleapis.com/css2?family=DM+Sans:ital,opsz,wght@0,9..40,100..1000;1,9..40,100..1000&display=swap');
@import url('https://fonts.googleapis.com/css2?family=Source+Sans+3:ital,wght@0,200..900;1,200..900&display=swap');
@import url('https://fonts.googleapis.com/css2?family=Merriweather:ital,opsz,wght@0,18..144,300..900;1,18..144,300..900&display=swap');

.robotoFont{
  font-family: "Roboto Mono", monospace;
  font-optical-sizing: auto;
  font-style: normal;
}

.notificacion{
  position: fixed;
  top: 2em;
  left: 50%;
  transform: translateX(-50%);
  max-width: 90vw;
  padding: 1.2em 1.6em;
  border-radius: 12px;
  background-color: white;
  text-align: center;
  z-index: 1100;
  box-shadow: 0 8px 28px rgba(0,0,0,0.35);
}
.notificacion span {
  font-size: 14px;
  color: #1a1a1a;
  line-height: 1.45;
}

.colorPicker{
    background-color: none;
    border: 1px solid red;
    border-bottom: 50px solid red;
    cursor: pointer;
    border-radius: 3px;
    width: 100px;
    justify-content: center;
    align-items: center;
    text-align: center;
    user-select: none;
    font-weight: 300
}

.clr-field button{
  display: none;
}

.monserrat{
  font-family: "Montserrat", sans-serif;
  font-optical-sizing: auto;
  font-weight: 400;
  font-style: normal;
}

.Ralway{
  font-family: "Raleway", sans-serif;
  font-optical-sizing: auto;
  font-weight: 400;
  font-style: normal;
}

.playwrite{
  font-family: "Playwrite DE Grund", cursive;
  font-optical-sizing: auto;
  font-weight: 200;
  font-style: normal;
}

.lato{
  font-family: "Lato", sans-serif;
  font-weight: 400;
  font-style: normal;
}

.poppins-regular {
  font-family: "Poppins", sans-serif;
  font-weight: 400;
  font-style: normal;
}

.Arimo{
  font-family: "Arimo", sans-serif;
  font-optical-sizing: auto;
  font-weight: 400;
  font-style: normal;
}

.font-inter { font-family: "Inter", sans-serif; font-weight: 400; }
.font-open-sans { font-family: "Open Sans", sans-serif; font-weight: 400; }
.font-quicksand { font-family: "Quicksand", sans-serif; font-weight: 500; }
.font-oswald { font-family: "Oswald", sans-serif; font-weight: 500; }
.font-bebas-neue { font-family: "Bebas Neue", sans-serif; font-weight: 400; letter-spacing: 1px; }
.font-dm-sans { font-family: "DM Sans", sans-serif; font-weight: 400; }
.font-source-sans { font-family: "Source Sans 3", sans-serif; font-weight: 400; }
.font-merriweather { font-family: "Merriweather", serif; font-weight: 400; }

/* Constructor de URL del Streaming Principal */
.streamingBuilder {
  display: flex;
  flex-direction: column;
  gap: 8px;
  margin: 1em 0;
  max-width: 600px;
}
.streamingFields {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  align-items: center;
}
.streamingServerSelect { flex: 2 1 200px; min-width: 180px; }
.streamingPortInput { flex: 1 1 100px; min-width: 90px; max-width: 130px; }
.streamingPathInput { flex: 1 1 110px; min-width: 100px; max-width: 160px; }
.streamingPreview {
  font-size: 12px;
  color: #555;
  word-break: break-all;
}
.streamingPreview code {
  background: #f1f1f1;
  padding: 2px 6px;
  border-radius: 3px;
  color: #ce0011;
  font-size: 12px;
}

/* Nota informativa para campos opcionales */
.helperNote {
  display: block;
  margin-top: 0.6em;
  padding: 8px 10px;
  background: rgba(206, 0, 17, 0.06);
  border-left: 3px solid #ce0011;
  border-radius: 4px;
  font-size: 12px;
  color: #444;
  line-height: 1.45;
}
.helperNote b { color: #1a1a1a; }

/* Estilo del select de fuentes */
#floatingSelect {
  background-color: #fff;
  border: 1.5px solid rgba(206, 0, 17, 0.25);
  border-radius: 6px;
  font-size: 15px;
  cursor: pointer;
  transition: border-color 0.15s ease, box-shadow 0.15s ease;
}
#floatingSelect:focus {
  border-color: #ce0011;
  box-shadow: 0 0 0 3px rgba(206, 0, 17, 0.18);
}
#floatingSelect option {
  font-size: 15px;
  padding: 8px;
}

.colorPalette {
  border: 1px solid rgba(0, 0, 0, 0.199);
  width: 120px;
  height: 140px;
  border-radius: 6px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: safe;
  font-size: 20px;
  font-weight: lighter;
  color: #505050;
  margin: 1em
}

.colorDiv{
  display: flex
}

.bloqueSpacing{
  margin-top: 3.5em;
  margin-bottom: 3.5em;
}

.bloqueSpacingSpecial{
  margin-top: 2.3em;
  margin-bottom: 3.5em;
}

.colorPalette input{
  border: 0px;
  width: 118px;
  height: 90px;
  border-radius: 6px;
  outline: none;
  cursor: pointer
}

.addRadio{
  display: flex;
  flex-direction: row;
  max-width: 400px;
  margin-top: 0em
}

.infoText{
  font-size: 14px;
  color: #505050c4;
}

.linkRadios{
  max-width: 400px;
}

.upDown{
  display: flex;
  flex-direction: column-reverse;
  justify-content: center;
  align-items: center;
}

.trashIcon {
  margin-left: 0px;
}

.LiPanel{
  display: flex;
  align-items: center;
}

.stationsList{
  display: flex;
  padding-top: 1em;
  flex-wrap: wrap
}

.linkInput{
  display: flex;
  flex-direction: column
}

.dataInputs{
  margin-top: 1em;
  margin-bottom: 1em
}

.stationCard{
  padding: 1em;
  width: 260px;
  margin-right: 1.6em;
  margin-top: 0.6em;
}

.nameInput{
  margin-top: 1em;
  margin-bottom: 1em;
}

ul{
  padding: 0px;
}

.linkLi{
  margin-top: 1em;
  border: 1px solid rgba(128, 128, 128, 0.589);
  padding: 0.7em;
  border-radius: 5px;
  list-style: none;
  justify-content: space-between;
  align-items: center;
  display: flex;
}

.liData{
  display: flex;
  flex-direction: column;
  flex: 1 1 auto;
  min-width: 0;
  margin-bottom: 0.4em;
}
.liData input{
  width: 100%;
}

.metadataInputs{
  display: flex;
  flex-direction: row;
}

.metadataInputs input{
  max-width: 400px;
}

.previewImage{
  border-radius: 8px;
  border: 1px solid rgba(128, 128, 128, 0.486);
  background-color: rgba(0, 0, 0, 0.171);
}

.loader {
  width: fit-content;
  font-weight: bold;
  font-family: monospace;
  font-size: 30px;
  color: #0000;
  background: linear-gradient(90deg,#C02942 calc(50% + 0.5ch),#000 0) right/calc(200% + 1ch) 100%;
  -webkit-background-clip: text;
          background-clip: text;
  animation: l7 2s infinite steps(11);
}
.loader:before {
  content:"Generando..."
}
@keyframes l7 {to{background-position: left}}

.codespace{
  width: 100%;
  background-color: rgba(128, 128, 128, 0.24);
  border-radius: 8px;
  padding: 1em;
  margin: 0;
  min-height: auto;
  font-family: "Space Mono", monospace;
  font-weight: 400;
  font-style: normal;
  word-break: break-all;
}

.iframe-result {
  margin: 2.5em 0 1.5em;
}
.iframe-result-header {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  margin-bottom: 10px;
}
.iframe-result-title {
  font-size: 14px;
  font-weight: 700;
  color: #1a1a1a;
  letter-spacing: 0.2px;
}
.iframe-open-link {
  font-weight: 600;
  white-space: nowrap;
}

.options {
    display: flex;
    justify-content: left;
    flex-wrap: wrap;
}

.step1 {
    display: flex;
    flex-direction: column;
    justify-content: left;
    align-items: left;
}

.item {
    padding: 1em;
    border-radius: 8px;
    border: 3px solid rgba(128, 128, 128, 0.158);
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    margin: 1em;
}

.item:hover {
    border: 3px solid rgba(255, 0, 0, 0.658);
    cursor: pointer;
}

.item img {
    border-radius: 8px;
    margin-bottom: 1em;
}

.buttonsStations{
  display: flex;
  flex-direction: row-reverse;
  margin-bottom: 1em;
}

.buttonsStations svg {
  margin-left: 1em;
  cursor: pointer
}

.editionButtons button{
  margin-left: 1em;
}

svg{
  cursor: pointer;
}

.v-enter-active {
  transition: all 0.3s ease-out;
}

.v-leave-active {
  transition: all 0.8s cubic-bezier(1, 0.5, 0.8, 1);
}

.v-enter-from,
.v-leave-to {
  transform: translateY(-20px);
  opacity: 0;
}

.InfoDiv {
  max-width: 400px;
}

.radioImgPreview{
  border-radius: 5px;
  margin-bottom: 1em;
}

/* === REDISEÑO 2026-05-06: secciones, layout 2-col, custom dropdown === */

/* Tarjeta blanca para cada sección del form */
.section-card {
  background: #ffffff;
  border: 1px solid rgba(0,0,0,0.06);
  border-radius: 12px;
  padding: 22px 24px;
  margin-bottom: 1.4em;
  box-shadow: 0 2px 8px rgba(0,0,0,0.04);
}

.section-title {
  font-size: 16px;
  font-weight: 700;
  color: #1a1a1a;
  margin: 0 0 4px 0;
  letter-spacing: -0.2px;
  display: flex;
  align-items: center;
  gap: 10px;
}

.section-subtitle {
  font-size: 13px;
  color: #666;
  margin: 0 0 18px 0;
  line-height: 1.45;
}

.optional-badge {
  display: inline-block;
  font-size: 10px;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  padding: 2px 8px;
  background: rgba(0,0,0,0.06);
  color: #666;
  border-radius: 10px;
}

/* Layouts de filas */
.row-2col {
  display: flex;
  flex-wrap: wrap;
  gap: 14px;
  margin-bottom: 14px;
}
.row-2col > * { flex: 1 1 240px; min-width: 0; }

/* Fila Diseño: color principal + color texto + fuente, todo 1 línea */
.row-design {
  display: flex;
  flex-wrap: wrap;
  gap: 16px;
  align-items: flex-start;
}
.row-design .field-color {
  flex: 0 0 auto;
  width: 130px;
}
.row-design .field-font {
  flex: 1 1 240px;
  min-width: 0;
}
.row-design .field-font .font-dropdown {
  max-width: none;
  width: 100%;
}

.row-logo {
  display: flex;
  flex-wrap: wrap;
  gap: 18px;
  align-items: flex-start;
}
.logo-input-area { flex: 1 1 320px; min-width: 0; }
.logo-preview-area {
  flex: 0 0 auto;
  width: 130px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.previewPlaceholder {
  width: 120px;
  height: 120px;
  border-radius: 8px;
  border: 2px dashed rgba(206, 0, 17, 0.2);
  display: flex;
  align-items: center;
  justify-content: center;
  color: #999;
  font-size: 12px;
  text-align: center;
}

/* Etiquetas y hints de campo */
.field-group {
  display: flex;
  flex-direction: column;
  gap: 4px;
  margin-bottom: 14px;
}
.field-label {
  font-size: 13px;
  font-weight: 600;
  color: #333;
  margin-bottom: 2px;
}
.req {
  color: #ce0011;
  font-weight: 700;
  margin-left: 2px;
}
.optional {
  color: #888;
  font-weight: 400;
  font-size: 12px;
  margin-left: 4px;
}
.field-hint {
  font-size: 12px;
  color: #666;
  font-style: italic;
}

/* Radio options con descripción */
.radio-options {
  display: flex;
  flex-wrap: wrap;
  gap: 12px;
}
.radio-option {
  flex: 1 1 280px;
  display: flex;
  align-items: flex-start;
  gap: 12px;
  padding: 14px 16px;
  border: 2px solid rgba(0,0,0,0.08);
  border-radius: 10px;
  cursor: pointer;
  transition: border-color 0.15s ease, background 0.15s ease;
  margin: 0;
}
.radio-option:hover { border-color: rgba(206,0,17,0.4); }
.radio-option.active {
  border-color: #ce0011;
  background: rgba(206,0,17,0.04);
}
.radio-option .form-check-input {
  margin-top: 4px;
  cursor: pointer;
  flex-shrink: 0;
}
.radio-content {
  display: flex;
  flex-direction: column;
  gap: 2px;
}
.radio-label {
  font-size: 14px;
  font-weight: 600;
  color: #1a1a1a;
}
.radio-desc {
  font-size: 12px;
  color: #666;
  line-height: 1.4;
}

/* Backups list */
.backupAddRow {
  display: flex;
  gap: 8px;
  align-items: center;
}
.backupAddRow .form-control { flex: 1; }
.backupAddRow .btn { flex-shrink: 0; white-space: nowrap; }

.backupsList {
  margin-top: 0.6em;
  padding: 0;
  list-style: none;
}

/* === Custom font dropdown === */
.font-dropdown {
  position: relative;
  width: 100%;
  max-width: 360px;
  user-select: none;
}
.font-dropdown-trigger {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  background: #fff;
  border: 1.5px solid rgba(206, 0, 17, 0.25);
  border-radius: 8px;
  padding: 10px 14px;
  font-size: 15px;
  cursor: pointer;
  transition: border-color 0.15s ease, box-shadow 0.15s ease;
}
.font-dropdown-trigger:hover { border-color: rgba(206,0,17,0.5); }
.font-dropdown-open .font-dropdown-trigger {
  border-color: #ce0011;
  box-shadow: 0 0 0 3px rgba(206, 0, 17, 0.18);
}
.font-dropdown-current {
  flex: 1;
  text-align: left;
  color: #1a1a1a;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.font-dropdown-caret {
  color: #ce0011;
  font-weight: 800;
  margin-left: 10px;
  transition: transform 0.15s ease;
}
.font-dropdown-open .font-dropdown-caret { transform: rotate(180deg); }

.font-dropdown-menu {
  position: absolute;
  top: calc(100% + 4px);
  left: 0;
  right: 0;
  max-height: 320px;
  overflow-y: auto;
  background: #fff;
  border: 1px solid rgba(0,0,0,0.1);
  border-radius: 8px;
  padding: 6px;
  margin: 0;
  list-style: none;
  z-index: 1000;
  box-shadow: 0 8px 28px rgba(0,0,0,0.18);
}
.font-dropdown-item {
  padding: 9px 12px;
  border-radius: 5px;
  cursor: pointer;
  font-size: 16px;
  color: #1a1a1a;
  transition: background-color 0.1s ease;
}
.font-dropdown-item:hover { background-color: rgba(206, 0, 17, 0.08); }
.font-dropdown-item-active {
  background-color: rgba(206, 0, 17, 0.14);
  color: #ce0011;
  font-weight: 600;
}

/* Mobile: stack secciones */
@media (max-width: 600px) {
  .section-card { padding: 16px 14px; }
  .section-title { font-size: 15px; }
  .row-2col { gap: 10px; }
  .row-logo { flex-direction: column; }
  .logo-preview-area { width: 100%; justify-content: flex-start; }
  .radio-options { flex-direction: column; }
}
</style>